import script from "./SidebarMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarMobile.vue?vue&type=script&setup=true&lang=js"

import "./SidebarMobile.vue?vue&type=style&index=0&id=4000450b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4000450b"]])

export default __exports__